import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import ProductsPage from './pages/ProductsPage';
import ProductPage from './pages/ProductPage';
import AboutPage from './pages/AboutPage';
import ResearchPage from './pages/ResearchPage';
import NewsPage from './pages/NewsPage';
import ArticlePage from './pages/ArticlePage';
import StaffProfilePage from './pages/StaffProfilePage';
import ContactPage from './pages/ContactPage';
import ScrollToTop from './components/ScrollToTop';
export function AppRouter() {
  return <BrowserRouter data-id="element-27" data-mp="nrth9mvn4e5b">
      <ScrollToTop data-id="element-28" data-mp="9u4yckl4vh2w" />
      <Routes data-id="element-29" data-mp="9uwrzpv674qj">
        <Route path="/" element={<App data-id="element-31" data-mp="9vy4lyru3zad" />} data-id="element-30" data-mp="9v6j5grybhxt" />
        <Route path="/about" element={<AboutPage data-id="element-33" data-mp="dv6w0wzejl2r" />} data-id="element-32" data-mp="9whm5edkolnv" />
        <Route path="/products" element={<ProductsPage data-id="element-35" data-mp="dxt36vidrykg" />} data-id="element-34" data-mp="dwruuysr1q6f" />
        <Route path="/products/microbiota-reset-protocol" element={<ProductPage data-id="element-37" data-mp="2461uuryfnd4t" />} data-id="element-36" data-mp="248fkglacfx4z" />
        <Route path="/research" element={<ResearchPage data-id="element-39" data-mp="288g72t7ljen4" />} data-id="element-38" data-mp="28a9guhdiaezc" />
        <Route path="/news" element={<NewsPage data-id="element-41" data-mp="2903p9i1iau1w" />} data-id="element-40" data-mp="287n9ahqm7zh4" />
        <Route path="/news/:articleId" element={<ArticlePage data-id="element-43" data-mp="28yafhtvljtpo" />} data-id="element-42" data-mp="28zbrc0kfsk8g" />
        <Route path="/team/:staffId" element={<StaffProfilePage data-id="element-45" data-mp="24090bk1akejh" />} data-id="element-44" data-mp="241acxsxyh93b" />
        <Route path="/contact" element={<ContactPage data-id="element-47" data-mp="2ipx0ghxql75m" />} data-id="element-46" data-mp="23z7lr5l2h9x0" />
      </Routes>
    </BrowserRouter>;
}